module.exports = "/_next/static/resources/photo-1-4a7b6f87c2aa780a94c88d557ab4ab39.webp";